import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { BaseInput } from "theme/components/atoms/Form/Input/Input";
import withFormHandlers from "theme/components/atoms/Form/Input/withFormHandlers";
import classNames from "classnames";
const RadioGroup = ({ values, renderRadio, ...props }) => {
  const {
    getErrors,
    isValid,
    isPristine,
    isDirty,
    name,
    value: currentValue,
    id,
    onChange,
    showNoneRadio = false,
    appearance = "radio",
    ...rest
  } = props;
  const errors = getErrors();

  return (
    <BaseInput
      errorAppearance="start"
      input={
        <>
          {props.label && (
            <div
              key={`radio-group-label-${id || name}`}
              className={classNames("radio-group__label", {
                "label--required": props.required,
              })}
            >
              {props.label}
            </div>
          )}
          <div className={`radio-group radio-group--${appearance}`}>
            {showNoneRadio
              ? renderRadio({
                  ...rest,
                  name: name,
                  id: `NONE-${id || name}`,
                  value: "",
                  checked: !currentValue,
                  onChange: () => {
                    onChange("");
                  },
                })
              : null}
            {values.map((value, index) => {
              const itemId = `${id || name}-${
                typeof value === "string" || typeof value === "number"
                  ? value
                  : index
              }`;
              return renderRadio({
                ...rest,
                name: name,
                id: itemId,
                key: itemId,
                value: value,
                checked: value === currentValue,
                onChange: () => onChange(value),
              });
            })}
          </div>
        </>
      }
      help={props.help}
      errors={errors}
      {...props.baseInputProps}
    />
  );
};

RadioGroup.propTypes = {
  renderRadio: PropTypes.func.isRequired,
  values: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
};

export default withFormHandlers({
  getValueFromEvent: (value) => value,
  requiredMessage: (
    <FormattedMessage
      id="components.atoms.Form.Input.RadioGroup.requiredError"
      defaultMessage="This option is required"
    />
  ),
})(RadioGroup);
